import { RouteObject } from "react-router-dom";
import MainLayout from "@/containers/layout/MainLayout";

import { RequireData } from "./Require";
import Loadable from "@/components/Loadable";
import { lazy } from "react";

const Stepper = Loadable(lazy(() => import("@/containers/pages/General/Stepper")));

const MainRoutes: Array<RouteObject> = [
  {
    path: "/",
    element: (
      <MainLayout>
        <RequireData />
      </MainLayout>
    ),
    children: [
      {
        path: "",
        element: <Stepper />,
      },
    ],
  },
];

export default MainRoutes;
